module.exports = "/_next/static/images/DataCollection-9b6c2423367e0f8ac112813cd3838e67.webp";